import { LazyQueryHookOptions, QueryTuple, useLazyQuery } from "@apollo/client";
import { GET_ACTUAL_ACTUALS } from "./actuals.queries";
import { IActualsInput, IListActualSuSasQuery } from "./actuals";

export const useGetActualActuals = (
  options?: LazyQueryHookOptions<IListActualSuSasQuery, IActualsInput>
): QueryTuple<IListActualSuSasQuery, IActualsInput> => {
  return useLazyQuery(GET_ACTUAL_ACTUALS, options);
};
